import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { formatDateTime } from '../../../utils/feedback';

import { RootStyled } from './styles';

export default function ClosedWarning({ lastUpdate }) {
  const navigate = useNavigate();

  return (
    <RootStyled>
      <Typography sx={{ fontWight: 400, fontSize: '1rem' }}>
        Este ticket foi encerrado em:{' '}
        <Typography fontSize="1rem" component="span" fontWeight="bold">
          {formatDateTime(lastUpdate)}
        </Typography>
      </Typography>
      <Button
        sx={{ mt: 2 }}
        variant="contained"
        color="primary"
        onClick={() => navigate('/new-ticket')}
      >
        Abrir novo ticket
      </Button>
    </RootStyled>
  );
}
